import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Spinner from '../../components/reusable/spinner/spinner.component';

import Client from '../../tools/client';

import {
    BackLink,
    ContentContainer,
    MainContainer,
    MainTitle
} from '../../styles/page.styles';

const client = new Client();

const InventoryPage = () => {
    const navigate = useNavigate();
    const [ loading, setLoading ] = useState(true);
    const { id } = useParams();
    const [ inventory, setInventory ] = useState({});

    useEffect(() => {
        getInventory();

        // eslint-disable-next-line
    }, []);

    const getInventory = async () => {
        setLoading(true);
        const res = await client.getInventoryById(id);

        if(res?.statusCode === 404) {
            setLoading(false);
            return
        }

        setInventory(res);
        setLoading(false);

        return res.data;
    }

    return (
        <MainContainer>
            <BackLink onClick={() => navigate(`/inventories`)}>
                Back To Inventories
            </BackLink>
            {loading ?
                <Spinner />
            :
                inventory.length === 0 ?
                    <MainTitle>No Inventory to Display</MainTitle>
                :
                    <ContentContainer>
                        <MainTitle>Inventory</MainTitle>
                    </ContentContainer>
            }
        </MainContainer>
    )
}

export default InventoryPage;